/** Customer credentials `/me` sliding-window ceiling — admin twin. */

const ME_ATTEMPT_CEILING_MAX = 20;
const ME_ATTEMPT_CEILING_WINDOW_MS = 60_000;
const meAttemptTimestamps: number[] = [];

export function pruneMeAttemptTimestamps(now: number): void {
  const cutoff = now - ME_ATTEMPT_CEILING_WINDOW_MS;
  let removeCount = 0;
  while (removeCount < meAttemptTimestamps.length) {
    const ts = meAttemptTimestamps[removeCount];
    if (ts === undefined || ts > cutoff) {
      break;
    }
    removeCount += 1;
  }
  if (removeCount > 0) {
    meAttemptTimestamps.splice(0, removeCount);
  }
}

export function isMeAttemptCeilingReached(now: number): boolean {
  pruneMeAttemptTimestamps(now);
  return meAttemptTimestamps.length >= ME_ATTEMPT_CEILING_MAX;
}

export function recordMeAttemptStart(now: number): void {
  pruneMeAttemptTimestamps(now);
  meAttemptTimestamps.push(now);
}

/**
 * Free a watermark slot (e.g. AbortError on signed-in hub `/me`).
 */
export function unrecordMeAttemptStart(now: number): void {
  const idx = meAttemptTimestamps.lastIndexOf(now);
  if (idx >= 0) {
    meAttemptTimestamps.splice(idx, 1);
  }
}

/** Test-only — clear `/me` ceiling watermark between Jest cases. */
export function resetMeAttemptTimestampsForTests(): void {
  meAttemptTimestamps.length = 0;
}

/** Test-only — current watermark count after prune. */
export function getMeAttemptCountForTests(now: number = Date.now()): number {
  pruneMeAttemptTimestamps(now);
  return meAttemptTimestamps.length;
}

/** DEV / G16 handoff — watermark length (latched always false — silence retired). */
export function getMeAttemptCeilingDevSnapshot(): {
  count: number;
  latched: boolean;
} {
  return {
    count: meAttemptTimestamps.length,
    latched: false,
  };
}
